<template>
  <div v-if="errors">
          <div class="p-3 mb-2 bg-danger text-white" v-for="error in errors[0]">
            <p><strong>{{ error.title }}</strong></p>
            <p>{{ error.detail }}</p>
          </div>
  </div>

</template>

<script>
    export default {
        name: "BaseErrors",
        props: {
            errors: {
                type: Array,
                default: []
            },
        },
        data() {
            return {
            };
        },
    };
</script>

<style scoped lang="scss">

</style>
